import React from 'react';
import { Clock, FileText, Shield, Zap, Calculator } from 'lucide-react';
import { Button } from '../ui/button';

export default function WelcomeStep({ onNext }) {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary/70 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Zap className="w-10 h-10 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2">
          Bienvenido a Zentro!
        </h2>
        <p className="text-slate-600 max-w-md mx-auto">
          Vamos a configurar tu cuenta para que puedas empezar a gestionar tus servicios administrativos de forma eficiente.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-slate-50 rounded-xl p-5 text-center">
          <Clock className="w-8 h-8 text-primary mx-auto mb-3" />
          <h3 className="font-semibold text-slate-900 mb-1">10-15 minutos</h3>
          <p className="text-sm text-slate-600">Tiempo estimado para completar</p>
        </div>
        <div className="bg-slate-50 rounded-xl p-5 text-center">
          <FileText className="w-8 h-8 text-primary mx-auto mb-3" />
          <h3 className="font-semibold text-slate-900 mb-1">Documentos</h3>
          <p className="text-sm text-slate-600">Ten a mano tu NIF/CIF e IBAN</p>
        </div>
        <div className="bg-slate-50 rounded-xl p-5 text-center">
          <Shield className="w-8 h-8 text-primary mx-auto mb-3" />
          <h3 className="font-semibold text-slate-900 mb-1">Seguro</h3>
          <p className="text-sm text-slate-600">Tus datos estan protegidos</p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-xl p-5">
        <h4 className="font-semibold text-blue-900 mb-3">Que vamos a configurar?</h4>
        <ul className="space-y-2 text-sm text-blue-800">
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">1</span>
            <span><strong>Datos fiscales:</strong> Razon social, NIF/CIF, domicilio fiscal, regimen de IVA</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">2</span>
            <span><strong>Facturacion:</strong> Serie, numeracion, logo, metodo de cobro por defecto</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">3</span>
            <span><strong>Contactos:</strong> Administrador principal, contacto de gestoria (si aplica)</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 rounded-full bg-blue-200 text-blue-800 flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">4</span>
            <span><strong>Modo de Contabilidad:</strong> Elige entre integracion con Holded o modulos nativos de Zentro</span>
          </li>
        </ul>
      </div>

      {/* New info about accounting modes */}
      <div className="bg-gradient-to-r from-green-50 to-blue-50 border border-green-200 rounded-xl p-5">
        <div className="flex items-start gap-3">
          <Calculator className="w-6 h-6 text-green-600 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-semibold text-slate-900 mb-2">Nuevo: Elige tu modo de contabilidad</h4>
            <p className="text-sm text-slate-700">
              Ahora puedes elegir como gestionar tu facturacion:
            </p>
            <ul className="mt-2 space-y-1 text-sm text-slate-600">
              <li><strong>Holded:</strong> Si ya tienes cuenta en Holded, integrala para sincronizar automaticamente.</li>
              <li><strong>Zentro Nativo:</strong> Usa nuestros modulos integrados sin necesidad de software externo.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4">
        <Button size="lg" onClick={() => onNext(null)} data-testid="start-onboarding-btn">
          Comenzar configuracion
        </Button>
      </div>
    </div>
  );
}

